exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{margin-left:180px}@media screen and (max-width:768px){.footer{margin-left:0}}.footer .social a{border-bottom:none!important}.footer .fa.fa-heart{color:red}", ""]);

// exports
